import React, { PropsWithChildren, useContext } from 'react'
import styled from 'styled-components'
import { CardDesignCarousel } from '../../../components/CardDesignCarousel/CardDesignCarousel'
import { CardDesignItem } from '../../../components/CardDesignCarousel/CardDesignItem'
import { GlobalContext } from '../../../globals/context'
import { truncate } from '../../../utils/truncate'
import { DetailArticlesFragment } from '@gql'
import { StyledCardBody } from '../../../components/CardDesignCarousel/styledCardDesignCarousel'

const StyleRelatedArticlesCarousel = styled(CardDesignCarousel)`
  margin-bottom: ${props => props.theme.typography.pxToRem(99)};
`

export type RelatedArticlesProps = {
  data: DetailArticlesFragment[]
}

export const RelatedArticles: React.FC<PropsWithChildren<RelatedArticlesProps>> = ({ data }) => {
  const { fallback } = useContext(GlobalContext)

  if (fallback?.globalSet?.__typename !== 'siteSettings_GlobalSet') {
    return null
  }

  const { newsFallbackImage } = fallback.globalSet

  return(
    <StyleRelatedArticlesCarousel columns={3} $overflow>
      {data.map((item, index) => {
        if (item.__typename !== 'news_newsEntryType_Entry') {
          return null
        }

        const useNewBanner = item.useNewBanner === true
        const banner = useNewBanner ? item.secondaryPageBanner?.[0] : item.newsDetailBanner?.[0]
        const bannerImage = banner?.image?.[0]?.url ?? newsFallbackImage?.[0]?.url

        console.log({ useNewBanner, banner, item })

        return (
          <CardDesignItem key={index} href={item.uri ? `/${item.uri}` : '#'}>
            <CardDesignItem image src={bannerImage} alt="" layout="fill" objectFit="cover" objectPosition="center" />
            <StyledCardBody>
              <CardDesignItem date>{new Date(item.postDate).toLocaleString('en-AU', { year: 'numeric', month: 'short', day: 'numeric' })}</CardDesignItem>
              <CardDesignItem title>{item?.title ? truncate(item.title, 75) : 'Untitled'}</CardDesignItem>
            </StyledCardBody>
          </CardDesignItem>
        )})}
    </StyleRelatedArticlesCarousel>
  )
}
